import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { settingsService } from "../../services/settings";
import Button from "../common/Button";
import toast from "react-hot-toast";
import { Plus, X } from "lucide-react";

const LeadSources = () => {
  const queryClient = useQueryClient();
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: settingsService.get,
  });
  const [newSource, setNewSource] = useState("");
  const mutation = useMutation({
    mutationFn: (sources) => settingsService.update({ leadSources: sources }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
      toast.success("Lead sources updated");
    },
  });

  const addSource = () => {
    if (!newSource.trim()) return;
    const updated = [...(settings?.leadSources || []), newSource.trim()];
    mutation.mutate(updated);
    setNewSource("");
  };

  const removeSource = (source) => {
    const updated = settings?.leadSources.filter((s) => s !== source);
    mutation.mutate(updated);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addSource();
    }
  };

  return (
    <div className="max-w-lg">
      <div className="flex gap-2 mb-6">
        <input
          value={newSource}
          onChange={(e) => setNewSource(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Enter new lead source..."
          className="flex-1 px-3.5 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 hover:border-gray-400 transition-all"
        />
        <Button onClick={addSource} disabled={!newSource.trim()}>
          <Plus className="w-4 h-4 mr-1" />
          Add
        </Button>
      </div>
      <div className="space-y-2">
        {settings?.leadSources?.length > 0 ? (
          settings.leadSources.map((src, idx) => (
            <div
              key={idx}
              className="flex items-center justify-between px-4 py-3 bg-gray-50 rounded-lg group hover:bg-gray-100 transition-colors"
            >
              <span className="text-sm text-gray-700">{src}</span>
              <button
                onClick={() => removeSource(src)}
                className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg opacity-0 group-hover:opacity-100 transition-all"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-400 text-center py-6">No lead sources configured</p>
        )}
      </div>
    </div>
  );
};

export default LeadSources;
